import React from 'react'

const Bar = ({
  nombre,
  baseline,
  cantidad,
  onShowPath,
  showPathButton,
  loading,
  setLoading,
}) => {
  const total = baseline + cantidad
  const baselinePercentage = Math.abs(baseline / total) * 100
  const cantidadPercentage = Math.abs(cantidad / total) * 100

  function formatearNumero(numero) {
    // Convertir el número a string
    const numStr = numero.toString();
    
    // Separar la parte entera y decimal
    const partes = numStr.split('.');
    const parteEntera = partes[0];
    
    // Formatear la parte entera
    const longitud = parteEntera.length;
    let resultado;
    
    if (longitud <= 3) {
        resultado = parteEntera;
    } else if (longitud <= 6) {
        resultado = `${parteEntera.slice(0, -3)},${parteEntera.slice(-3)}`;
    } else {
        const millones = parteEntera.slice(0, -6);
        const miles = parteEntera.slice(-6, -3);
        const cientos = parteEntera.slice(-3);
        resultado = `${millones}'${miles},${cientos}`;
    }
    
    // Agregar la parte decimal si existe
    if (partes.length > 1) {
        resultado += `.${  partes[1]}`;
    }
    
    return resultado;
}

  return (
    <div className="bar">
      <span className="bar-name">{nombre}</span>
      <div className="bar-container">
        {baseline !== 0 && (
          <div
            className="bar-baseline"
            style={{ width: `${Math.abs(baselinePercentage)}%` }}
          >
            <span className="bar-value">
              {formatearNumero(baseline.toFixed(2))}
            </span>
          </div>
        )}
        {cantidad !== 0 && (
          <div
            className="bar-cantidad"
            style={{ width: `${Math.abs(cantidadPercentage)}%` }}
          >
            <span className="bar-value">
              {cantidad > 0 ? '+' : ''}
              {formatearNumero(cantidad.toFixed(2))}
            </span>
          </div>
        )}
      </div>
      {showPathButton && (
        <button
          className="show-path-button"
          onClick={onShowPath}
          disabled={loading}
        >
          📈
        </button>
      )}
    </div>
  )
}

const TreeItem = ({
  item,
  onToggle,
  openItems,
  level = 0,
  path = [],
  setCurrentPath,
  loading,
  setLoading,
}) => {
  const itemKey = `level-${level}:${item.nombre}`
  const isOpen = openItems.includes(itemKey)
  const hasChildren = item.hijos && item.hijos.length > 0

  const currentPath = [...path, { value: item.nombre, nivel: level }]

  const handleShowPath = () => {
    if (setCurrentPath) {
      setCurrentPath(currentPath.slice(1))
    }
  }

  return (
    <div className={`tree-item level-${level}`}>
      <div className="item-header" style={{ marginLeft: `${level * 20}px` }}>
        <div className="toggle-container">
          {hasChildren && (
            <span
              className="toggle-icon"
              onClick={() => onToggle(itemKey, level)}
            >
              {isOpen ? '▼' : '▶'}
            </span>
          )}
        </div>
        <Bar
          nombre={item.nombre}
          baseline={item.baseline_sum}
          cantidad={item.cantidad_sum}
          onShowPath={handleShowPath}
          showPathButton={level > 0} // No mostrar para "Total"
          loading={loading}
          setLoading={setLoading}
        />
      </div>
      {isOpen && hasChildren && (
        <div className="children">
          {item.hijos.map((child) => (
            <TreeItem
              key={`${itemKey}-${child.nombre}`}
              item={child}
              onToggle={onToggle}
              openItems={openItems}
              level={level + 1}
              path={currentPath}
              setCurrentPath={setCurrentPath}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default TreeItem
